import React from "react";
import StarterKit from "@tiptap/starter-kit";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuButtonBulletedList,
  MenuControlsContainer,
  RichTextEditorProvider,
  RichTextField,
} from "mui-tiptap";
import { useEditor } from "@tiptap/react";
import { useField } from "formik";

const RichEditor = ({ name }: { name: string }) => {
  const [field, _, helpers] = useField({ name });
  const editor = useEditor({
    extensions: [StarterKit.configure({ trailingNode: false })],
    content: field.value || "",
    // With Tiptap v3, set shouldRerenderOnTransaction to true, as mui-tiptap currently relies
    // on rerenders to keep controls/children reactive to support both Tiptap v2 and v3.
    // (https://github.com/sjdemartini/mui-tiptap/issues/425 tracks v3-specific handling.)
    shouldRerenderOnTransaction: true,
    onUpdate: ({ editor }) => {
      helpers.setValue(editor.getHTML());
    },
    onBlur: () => {
      helpers.setTouched(true);
    },
    onFocus: () => {
      helpers.setTouched(true);
    },
  });
  return (
    <>
      <RichTextEditorProvider editor={editor}>
        <RichTextField
          controls={
            <MenuControlsContainer>
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuButtonBulletedList />
              {/* Add more controls of your choosing here */}
            </MenuControlsContainer>
          }
        />
      </RichTextEditorProvider>
    </>
  );
};

export default RichEditor;
